( function ( _s ) {
	const modalId = 'team-grid-modal';
	const _teamGridModal = _s( '#' + modalId );

	const loadMicroModalLibrary = ( libraryLoadedStatment, libArr, callback ) => {
		if ( libraryLoadedStatment ) {
			callback();
		} else {
			window.fetchInject( libArr ).then( () => {
				callback();
			} );
		}
	};

	_s.fn.teamGrid = function () {
		return this.el.forEach( el => {
			const _self = _s( el );
			const _teamGridCards = _self.find( '.team-grid-item' );
			let keyDownElement = false;

			const loadModalContent = _target => {
				const _modalContent = _target.hasClass( 'team-grid-item' )
					? _target.find( '.team-grid-item-modal-content' )
					: _target.closest( '.team-grid-item' ).find( '.team-grid-item-modal-content' );

				_teamGridModal.find( '.modal__content' ).html( '' ).append( _modalContent.html() );
			};

			const showModal = () => {
				window.MicroModal.show( modalId, {
					disableScroll: true,
				} );
			};

			loadMicroModalLibrary(
				typeof window.MicroModal === 'object',
				[ 'https://unpkg.com/micromodal/dist/micromodal.min.js' ],
				() => {
					_teamGridCards.on( 'click', e => {
						if ( e.target.tagName.toLowerCase() === 'a' ) return; // Do nothing if phone or email addres links are clicked

						const _target = _s( e.target );

						loadModalContent( _target );

						showModal();
					} );

					_s( window ).on( 'keydown', e => {
						keyDownElement = e.target;
					} );

					_teamGridCards.on( 'keyup', e => {
						const _target = _s( e.target );

						/** Show modal only if the keyup event is preceded by a keydown event on the same element */
						if (
							window.isEventKeyEnter( e ) &&
							_target.hasClass( 'team-grid-item' ) &&
							keyDownElement === _target.firstElement()
						) {
							loadModalContent( _target );

							showModal();
						}

						keyDownElement = false;
					} );
				}
			);
		} );
	};

	_s( document ).ready( () => {
		_s( '.team-grid-module' ).teamGrid();
	} );
} )( window._s );
